import React from 'react';
import { connect } from 'react-redux';
import { fetchTipoUsuarios, fetchAccionesTipoUsuario } from '../../actions/usuariosActions';
import { useNavigate } from 'react-router-dom';
import { deleteAccionPredefinidaTipoUsuarioApi } from '../../api/axios';
import { toast } from 'react-toastify';
import BigSpinner from '../General/BigSpinner';


class TipoUsuarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tiposUsuariosOptions: [
                { value: 1, label: "Admin" },
                { value: 2, label: "Category" },
                { value: 3, label: "Seller" },
            ],
            selectedTipoUsuario: null,
            selectedTipoUsuarioData: null,
            acciones: null,
            loadingAcciones: false,
        };
    }

    componentDidMount() {
        this.getTiposUsuarios();
    }

    getTiposUsuarios = async () => {
        try {

            const response = await this.props.fetchTipoUsuarios();

            const data = response.data || response;

            const options = data.map(tu => ({
                value: tu.id,
                label: tu.descripcion
            }));

            this.setState({ tiposUsuariosOptions: options });

        } catch (e) {
            console.error("Error obteniendo tipos de usuario:", e);
        }
    };

    handleChangeTipoUsuario = async (selected) => {
        this.setState({
            selectedTipoUsuario: selected,
            selectedTipoUsuarioData: selected,
            acciones: null,
            loadingAcciones: true,
        });

        try {
            const acciones = await this.props.fetchAccionesTipoUsuario(selected.id);

            this.setState({
                acciones: acciones.data ?? [],
                loadingAcciones: false
            });
        } catch {
            this.setState({ loadingAcciones: false });
        }

    };

    goToTipoUsuarioNuevo = () => {
        this.props.navigate("/Usuarios/TipoUsuariosNuevo");
    };

    handleEliminarAccion = async (accionId) => {

        try {
            await deleteAccionPredefinidaTipoUsuarioApi(accionId);
            toast.success("Acción Predefinida borrada");

            // Actualizamos la lista local filtrando la acción eliminada
            this.setState(prev => ({
                acciones: prev.acciones.filter(a => a.id !== accionId)
            }));
        } catch (error) {
            toast.error("Error al eliminar la acción");
            console.error("Error al eliminar acción:", error);
        }
    };

    goToAccionPredefinidaTipoUsuarioNuevo = () => {
        const idTipo = this.state.selectedTipoUsuario?.id ?? this.state.selectedTipoUsuario?.value ?? null;

        // Enviamos también las acciones actuales para que el formulario pueda validar duplicados
        this.props.navigate("/Usuarios/AccionPredefinidaNuevo", { state: { idTipoUsuario: idTipo, accionesActuales: this.state.acciones ?? [] } });
    };


    render() {
        const { tiposUsuarios } = this.props;

        return (
            <>
                <div className="col-12 col-sm-6 d-flex align-items-center justify-content-between">
                    <h3 className="text-themecolor color-rojo-megatone m-0">Tipos de Usuarios</h3>

                    <button
                        type="button"
                        onClick={() => this.goToTipoUsuarioNuevo()}
                        className="btn btn-sm btn-green"
                    >
                        <i className="fa fa-plus-circle mx-1" />
                        Crear Tipo Usuario
                    </button>
                </div>

                <div className="row mt-4">
                    {/* Columna izquierda: Tipos de usuario */}
                    <div className="col-12 col-md-6">

                        <ul className="list-group">
                            {tiposUsuarios && tiposUsuarios.length > 0 ? (
                                tiposUsuarios.map((tipo) => (
                                    <li
                                        key={tipo.id}
                                        className={
                                            "list-group-item d-flex justify-content-between align-items-center " +
                                            (this.state.selectedTipoUsuario?.id === tipo.id ? "active" : "")
                                        }
                                        onClick={() => this.handleChangeTipoUsuario(tipo)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <span>{tipo.descripcion}</span>

                                        <button
                                            className="btn btn-sm btn-light"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.props.navigate(`/Usuarios/TipoUsuarioEditar/${tipo.id}`);
                                            }}
                                        >
                                            <i className="fa fa-edit me-1" />
                                        </button>
                                    </li>
                                ))
                            ) : (
                                <li className="list-group-item">No hay tipos de usuarios cargados.</li>
                            )}
                        </ul>
                    </div>

                    {/* Columna derecha: Acciones predefinidas */}
                    <div className="col-12 col-md-6">
                        <div className="row align-items-center mb-3">
                            <div className="col-md-8 d-flex align-items-center">
                                <h4 className="card-title ml-2">Acciones Predefinidas</h4>
                            </div>

                            <div className="col-md-4 d-flex justify-content-end">
                                {this.state.selectedTipoUsuario && (
                                    <button
                                        onClick={() => this.goToAccionPredefinidaTipoUsuarioNuevo()}
                                        type="button"
                                        className="btn btn-sm btn-green"
                                    >
                                        <i className="fa fa-plus-circle mx-1" />
                                        Crear Acción Predefinida
                                    </button>
                                )}
                            </div>
                        </div>

                        {this.state.selectedTipoUsuario ? (
                            <div className="mt-3">

                                {this.state.loadingAcciones && (
                                    <BigSpinner />
                                )}

                                {!this.state.loadingAcciones && this.state.acciones && this.state.acciones.length > 0 ? (
                                    <ul className="list-group">
                                        {this.state.acciones.map(acc => (
                                            <li
                                                key={acc.id}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                style={{ cursor: "default" }}
                                            >
                                                <span>{acc.accion.descripcion}</span>

                                                <i
                                                    className="fas fa-trash-alt"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.handleEliminarAccion(acc.id)}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                ) : !this.state.loadingAcciones ? (
                                    <p>No hay acciones configuradas.</p>
                                ) : null}
                            </div>
                        ) : (
                            <div className="alert alert-info">
                                Seleccioná un tipo de usuario para ver sus acciones predefinidas.
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }

}

const TipoUsuariosWrapper = (props) => {
    const navigate = useNavigate();
    return <TipoUsuarios {...props} navigate={navigate} />;
}

const mapStateToProps = (state) => ({
    tiposUsuarios: state.usuarios.tiposUsuarios?.data,
});

export default connect(mapStateToProps,
    {
        fetchTipoUsuarios,
        fetchAccionesTipoUsuario
    }
)(TipoUsuariosWrapper);
